import { declareProcType } from '@jurinfor/game-process';
import { setHintSemantic, HintSemantic } from './Hint';

declareProcType('setHint', setHintSemantic);
declareProcType('Hint', HintSemantic);
